<template>
  <div class="time_picker" :class="{ nosec: !useSec }">
    <div class="picker arrows" :style="{ opacity: !prepared ? 0 : 1 }">
      <div ref="hours" class="swiper-container hours">
        <div ref="hWrapper" class="swiper-wrapper">
          <div class="swiper-slide" id="tp-h-00">00</div>
          <div class="swiper-slide" v-for="i in 23" :id="`tp-h-${append0(i)}`">{{ append0(i) }}</div>
        </div>
      </div>
      <div ref="minutes" class="swiper-container minutes">
        <div ref="mWrapper" class="swiper-wrapper">
          <div class="swiper-slide" v-for="v in initMins" :id="`tp-m-${v}`">{{ v }}</div>
        </div>
      </div>
      <div v-if="useSec" ref="seconds" class="swiper-container seconds">
        <div ref="sWrapper" class="swiper-wrapper">
          <div class="swiper-slide" id="tp-s-00">00</div>
          <div class="swiper-slide" v-for="i in 59" :id="`tp-s-${append0(i)}`">{{ append0(i) }}</div>
        </div>
      </div>
      <div class="vizor"></div>
    </div>

    <div v-if="minSelector" class="c-btns c-time-range c-flex ac jc w100">
      <!--       <v-btn small flat :outline="type == 30" @click="type = 30" color="grey darken-1">30</v-btn>
 -->
      <v-btn small flat :outline="type == 15" @click="type = 15" color="grey darken-1">{{
        $T('common.timerange', { time: 15 })
      }}</v-btn>
      <v-btn small flat :outline="type == 5" @click="type = 5" color="grey darken-1">{{
        $T('common.timerange', { time: 5 })
      }}</v-btn>
      <v-btn small flat :outline="type != 30 && type != 15 && type != 5" @click="type = 0" color="grey darken-1">{{
        $T('common.all')
      }}</v-btn>
    </div>

    <div class="c-btns c-cfm c-flex ac jc w100">
      <v-btn small flat @click="onOk" color="clr-btn">{{ $T('button.ok') }}</v-btn>
      <v-btn small flat @click="onCancel" color="clr-btn-cancel">{{ $T('button.cancel') }}</v-btn>
    </div>
  </div>
</template>

<script>
var MIN30 = ['00', '30'];
var MIN15 = ['00', '15', '30', '45'];
var MIN5 = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

export default {
  props: {
    value: { type: String, required: false, default: '01:23' },
    defaultType: { type: Number, required: false, default: 15 },
    defaultSave: { type: Boolean, required: false, default: true },
    minSelector: { type: Boolean, required: false, default: true },
  },
  mounted() {
    var defaults = {
      pagination: '.swiper-pagination',
      slidesPerView: 3,
      freeMode: true,
      freeModeSticky: true,
      freeModeMomentumRatio: 0.25,
      freeModeVelocityRatio: 0.25,
      freeModeMinimumVelocity: 0.1,
      mousewheelControl: true,
      mousewheelSensitivity: 0.5,
      loop: true,
      loopAdditionalSlides: 5,
      direction: 'vertical',
      slideToClickedSlide: true,
      centeredSlides: true,
    };

    this.$nextTick(function() {
      var self = this;
      var preparing = setInterval(function() {
        if (!self.isAllWrapPrepared()) return;

        self.swiper.hours = new Swiper(
          self.$refs.hours,
          Object.assign({}, defaults, {
            initialSlide: Number(self.hour),
            on: {
              slideChange: self.onHoursSlideChange,
            },
          })
        );
        self.swiper.hours.mousewheel.enable();

        self.swiper.minutes = new Swiper(
          self.$refs.minutes,
          Object.assign({}, defaults, {
            initialSlide: self.initMinIdx,
            on: {
              slideChange: self.onMinutesSlideChange,
            },
          })
        );
        self.swiper.minutes.mousewheel.enable();

        if (self.useSec) {
          self.swiper.seconds = new Swiper(
            self.$refs.seconds,
            Object.assign({}, defaults, {
              initialSlide: Number(self.sec),
              on: {
                slideChange: self.onSecondsSlideChange,
              },
            })
          );
          self.swiper.seconds.mousewheel.enable();
        }

        self.prepared = true;
        clearInterval(preparing);
      }, 50);
    });
  },
  beforeDestroy() {
    if (!this.save) return;
    this.$emit('input', this.toResult());
  },
  data() {
    return {
      type: this.initType(),
      save: this.defaultSave,
      prepared: false,
      swiper: {
        hours: null,
        minutes: null,
        seconds: null,
      },
      hour: this.initTimes()[0],
      min: this.initTimes()[1],
      sec: this.initTimes().length == 2 ? '00' : this.initTimes()[2],
    };
  },
  computed: {
    useSec() {
      return this.initTimes().length == 3;
    },
    initMins() {
      if (this.type == 30) return MIN30;
      if (this.type == 15) return MIN15;
      if (this.type == 5) return MIN5;
      var mins = [];
      for (var i = 0; i < 60; i++) mins.push(this.append0(i));
      return mins;
    },
    initMinIdx() {
      if (this.type == 30) return this.toIdx(MIN30, this.min);
      if (this.type == 15) return this.toIdx(MIN15, this.min);
      if (this.type == 5) return this.toIdx(MIN5, this.min);
      return Number(this.min);
    },
  },
  watch: {
    type(n, o) {
      if (!this.swiper.minutes) return;
      this.adjustMin(n);
    },
  },
  methods: {
    isAllWrapPrepared() {
      return this.$refs.hWrapper && this.$refs.mWrapper && (!this.useSec || this.$refs.sWrapper);
    },
    initType() {
      var defT = this.defaultType;
      if (!this.minSelector || (defT != 30 && defT != 15 && defT != 5)) return 0;
      var v = this.initTimes()[1];
      if (defT >= 30 && MIN30.indexOf(v) >= 0) return 30;
      if (defT >= 15 && MIN15.indexOf(v) >= 0) return 15;
      if (defT >= 5 && MIN5.indexOf(v) >= 0) return 5;
      return 0;
    },
    initTimes() {
      var v = this.value ? this.value : this.$moment().format('HH:mm:ss');
      return v.split(':');
    },
    toIdx(arr, v) {
      var i = arr.indexOf(v);
      return i == -1 ? 0 : i;
    },
    append0(i) {
      return i < 10 ? '0' + i : i;
    },
    onHoursSlideChange() {
      this.hour = this.toVal(this.swiper.hours, this.hour);
    },
    onMinutesSlideChange() {
      this.min = this.toVal(this.swiper.minutes, this.min);
    },
    onSecondsSlideChange() {
      this.sec = this.toVal(this.swiper.seconds, this.sec);
    },
    toVal(swiper, def) {
      return swiper ? this.toIdxVal(swiper, swiper.activeIndex) : def;
    },
    toIdxVal(swiper, i) {
      var s = swiper.slides[i];
      if (s && s.id) return s.id.split('-')[2];
      console.warn(`there is no slide in swiper idx[${i}] return '00'`);
      return '00';
    },
    adjustMin(type, v) {
      var s = this.swiper.minutes;
      if (!v) {
        v = this.toIdxVal(s, s.activeIndex);
      }
      var idxs = [];
      for (var i = 0; i < s.slides.length; i++) {
        if (i != s.realIndex) idxs.push(i);
      }
      s.removeSlide(idxs);
      s.update();

      var mins;
      if (type == 30) mins = MIN30;
      else if (type == 15) mins = MIN15;
      else if (type == 5) mins = MIN5;
      else {
        mins = [];
        for (var i = 0; i < 60; i++) mins.push(this.append0(i));
      }

      var appends = [];
      var prepends = [];
      for (var i = 0, n = mins.length; i < n; i++) {
        if (v < mins[i]) appends.push(this.toMinSlide(mins[i]));
        if (v > mins[i]) prepends.unshift(this.toMinSlide(mins[i]));
      }

      s.appendSlide(appends);
      s.update();
      s.prependSlide(prepends);
      s.update();

      if (v == -1) return;
      this.$nextTick(function() {
        for (var i = 0; i < s.slides.length; i++) {
          if (v == this.toIdxVal(s, i)) {
            s.slideTo(i, 0);
            break;
          }
        }
      });
    },
    toMinSlide(v) {
      return `<div class="swiper-slide" id="tp-m-${v}">${v}</div>`;
    },
    toResult() {
      return this.useSec ? `${this.hour}:${this.min}:${this.sec}` : `${this.hour}:${this.min}`;
    },
    onOk() {
      this.$emit('input', this.toResult());
      this.$emit('ok');
    },
    onCancel() {
      this.save = false;
      this.$emit('cancel');
    },
  },
};
</script>
